import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import { setDatePickerDate } from 'reports/actions';
import LineChart from 'reports/DashboardReports/Charts/LineChartLayout/LineChart';
import RevenueColumnChart from 'reports/DashboardReports/Charts/RevenueChartLayout/RevenueColumnChart';
// eslint-disable-next-line max-len
import SalesByCategoryPieChart from 'reports/DashboardReports/Charts/SalesByCategoryChartLayout/SalesByCategoryPieChart';
import {
  completeMissingDatesInGroupedData,
  convertGroupedDataToColumnChartData,
  convertGroupedDataToLinearChartData,
  convertSalesGroupedDataToPieChartData,
  getSumOfGroupedData,
} from 'reports/DashboardReports/utils';
import { convertToMoneyAfterVat } from 'reports/utils';

import 'styles/reports/chart.scss';

const ReportsProps = ['forecastRevenue', 'actualSalesData', 'salesReport'];

class DashboardReportsLayout extends React.Component {
  UNSAFE_componentWillMount() {
    if (
      Math.round(
        moment.duration(this.props.lastDatesSelected.toDate.diff(this.props.lastDatesSelected.fromDate)).as('days'),
      ) !== 7
    ) {
      this.props.setDatePickerDate(
        moment(this.props.lastDatesSelected.fromDate).startOf('week'),
        moment(this.props.lastDatesSelected.fromDate).endOf('week'),
      );
    }
  }

  checkIfAllDataIsLoaded = () => ReportsProps.every((prop) => this.props[prop].lastRequestResponse);

  render() {
    const actualSales = (
      this.props.actualSalesData && this.props.actualSalesData.lastRequestResponse
        ? completeMissingDatesInGroupedData(
            this.props.actualSalesData.lastRequestResponse.grouped_by_day,
            this.props.lastDatesSelected,
          )
        : []
    ).map((day) => (day.deposit_amount ? { ...day, total: day.total - day.deposit_amount } : day));
    const forecastSales =
      this.props.forecastRevenue && this.props.forecastRevenue.lastRequestResponse
        ? this.props.forecastRevenue.lastRequestResponse
        : [];

    const salesGroupedByCategory =
      this.props.salesReport && this.props.salesReport.lastRequestResponse
        ? this.props.salesReport.lastRequestResponse.category_group
        : [];

    const dailyRebookingReport =
      this.props.dailyRebookingReport && this.props.dailyRebookingReport.lastRequestResponse
        ? completeMissingDatesInGroupedData(
            this.props.dailyRebookingReport.lastRequestResponse.grouped_by_day,
            this.props.lastDatesSelected,
          )
        : [];

    return (
      <div className="inner-wraper dashboard">
        {!this.checkIfAllDataIsLoaded() && (
          <div className="spinner-container">
            <div className="load-spinner" />
          </div>
        )}
        {this.checkIfAllDataIsLoaded() && (
          <React.Fragment>
            {actualSales && forecastSales && (
              <RevenueColumnChart
                actualSales={convertGroupedDataToColumnChartData(actualSales, this.props.lastDatesSelected, 'total')}
                forecastSales={convertGroupedDataToColumnChartData(
                  forecastSales,
                  this.props.lastDatesSelected,
                  'total',
                )}
                salesToDate={
                  (this.props.actualSalesData &&
                    this.props.actualSalesData.lastRequestResponse &&
                    this.props.actualSalesData.lastRequestResponse.total) ||
                  0
                }
                forecastSalesTotal={getSumOfGroupedData(forecastSales)}
                salonVatRate={this.props.salonVatRate}
              />
            )}
            {!!salesGroupedByCategory.length && (
              <SalesByCategoryPieChart
                data={convertSalesGroupedDataToPieChartData(salesGroupedByCategory)}
                salonVatRate={this.props.salonVatRate}
              />
            )}
            {this.props.actualSalesData && this.props.actualSalesData.lastRequestResponse && (
              <LineChart
                name="Average Bill Value"
                data={convertGroupedDataToLinearChartData(actualSales, 'average')}
                weekToDate={
                  this.props.actualSalesData && this.props.actualSalesData.lastRequestResponse
                    ? convertToMoneyAfterVat(this.props.actualSalesData.lastRequestResponse.average)
                    : ''
                }
                salonVatRate={this.props.salonVatRate}
              />
            )}
            {dailyRebookingReport.length > 0 && (
              <LineChart
                name="Rebooking Rate"
                data={convertGroupedDataToLinearChartData(dailyRebookingReport, 'percentage', 100)}
                suffix="%"
                weekToDate={
                  this.props.dailyRebookingReport && this.props.dailyRebookingReport.lastRequestResponse
                    ? `${(this.props.dailyRebookingReport.lastRequestResponse.percentage * 100).toFixed(0)}%`
                    : ''
                }
              />
            )}
          </React.Fragment>
        )}
      </div>
    );
  }
}

export function mapStateToProps(state) {
  const { reports } = state;
  const { lastDatesSelected, forecastRevenue, actualSalesData, salesReport, dailyRebookingReport, salonVatRate } =
    reports;
  return {
    salonVatRate,
    lastDatesSelected,
    forecastRevenue,
    actualSalesData,
    salesReport,
    dailyRebookingReport,
  };
}

export function mapDispatchToProps(dispatch) {
  return {
    setDatePickerDate(startDate, endDate) {
      dispatch(setDatePickerDate(startDate, endDate));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DashboardReportsLayout);
